import React, { createContext, useCallback, useContext, useMemo } from "react";
import PropTypes from "prop-types";

import { useAppConfig, useAuthEventHandler } from "./hooks";

export const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

function AuthProvider({ children }) {
  const { init, destroy } = useAppConfig();
  const { loading, user, autoSignIn } = useAuthEventHandler({
    onSignIn: useCallback(init, []),
    onSignOut: useCallback(destroy, []),
  });

  return (
    <AuthContext.Provider
      value={useMemo(() => {
        return { loading, user, autoSignIn };
      }, [loading, user, autoSignIn])}
    >
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = { children: PropTypes.node };

AuthProvider.defaultProps = { children: null };

export default AuthProvider;
